export default __webpack_public_path__ + "static/media/offer.a9ac1900.svg";